import { watch } from "vue";
import { ngFrameworkLoaded } from "../ng-integration";
import { useNgSession } from "../ng-session";

export const invokeWithLogin = async <T>(fn: () => T): Promise<T> => {
    const { isLoggedIn } = useNgSession();
    await ngFrameworkLoaded();
    if (isLoggedIn.value) {
        return await fn();
    } else {
        ng_fw.showLogin();
        return new Promise((resolve) => {
            watch(isLoggedIn, async (loggedIn) => {
                if (loggedIn) {
                    resolve(await fn());
                }
            });
        });
    }
};
